"use client";

import { createContext, useContext } from "react";
import type { RotationalCarouselContextType } from "./RotationalCarousel.types";

const RotationalCarouselContext =
  createContext<RotationalCarouselContextType | null>(null);

const useRotationalCarousel = () => {
  const ctx = useContext(RotationalCarouselContext);
  if (!ctx) {
    throw new Error(
      "useRotationalCarousel must be used within a <RotationalCarousel />",
    );
  }
  return ctx;
};

export { RotationalCarouselContext, useRotationalCarousel };
